export const COMPANY_TYPE_LABELS = {
  private_limited: "Private Limited Company",
  public_limited: "Public Company",
  opc: "One Person Company (OPC)",
  llp: "LLP",
  partnership: "Partnership",
  proprietorship: "Proprietorship",
  individual: "Individual",
  huf: "HUF",
  section_8: "Section 8",
  trust_society_ngo: "Trust / Society / NGO",
  fcra_org: "FCRA Organization",
  startup: "Startup",
  msme: "MSME",
};

export const COMPANY_TYPE_ORDER = [
  "private_limited",
  "public_limited",
  "opc",
  "llp",
  "partnership",
  "proprietorship",
  "individual",
  "huf",
  "trust_society_ngo",
  "fcra_org",
  "startup",
  "msme",
  "section_8",
];

export const companyTypeLabel = (t) =>
  COMPANY_TYPE_LABELS[t] || (t ? t.replace(/_/g, " ") : "—");

// -------------------------------------------------------------------
// Account status (Batch 1) — colour-coded badge tokens per spec
// -------------------------------------------------------------------
export const ACCOUNT_STATUSES = {
  pending_activation: {
    label: "Pending Activation",
    color: "#B45309",       // text
    background: "#FEF3C7",  // amber
    dot: "#F59E0B",
  },
  active: {
    label: "Active",
    color: "#166534",
    background: "#DCFCE7",
    dot: "#22C55E",
  },
  temp_disabled: {
    label: "Temporarily Disabled",
    color: "#9A3412",
    background: "#FFEDD5",
    dot: "#F97316",
  },
  suspended: {
    label: "Suspended",
    color: "#991B1B",
    background: "#FEE2E2",
    dot: "#DC2626",
  },
  expired: {
    label: "Expired",
    color: "#475569",
    background: "#F1F5F9",
    dot: "#94A3B8",
  },
  deactivated: {
    label: "Deactivated",
    color: "#1F2937",
    background: "#E5E7EB",
    dot: "#4B5563",
  },
};

export const accountStatusMeta = (s) =>
  ACCOUNT_STATUSES[s] || ACCOUNT_STATUSES.pending_activation;

// Financial-year start month options (Indian FY defaults to April = 4)
export const FY_START_MONTHS = [
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April (Indian FY)" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
];
